export const HOME_PATH = '/';
export const SIGN_IN_PATH = '/sign-in';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const PROFILE_PATH = '/profile';

export const INSIGHTS_TAB_SLUGS = {
    aiChats: 'ai-chats',
    aiFeedbacks: 'ai-feedback',
    visits: 'visits',
    pages: 'pages',
    files: 'files',
    data: 'data',
    exports: 'exports',
    pdfExports: 'pdf-exports',
    userFeedback: 'user-feedback',
    companyUsage: 'company-usage',
    search: 'search',
} as const;
export const INSIGHTS_PATH = '/insights';
export const INSIGHTS_TAB_PATH = `${INSIGHTS_PATH}/:tab?`;
export const INSIGHTS_AI_CHAT_PATH = `${INSIGHTS_PATH}/${INSIGHTS_TAB_SLUGS.aiChats}`;
export const INSIGHTS_AI_CHAT_DETAIL_PATH = `${INSIGHTS_AI_CHAT_PATH}/:chatId`;
export const INSIGHTS_AI_FEEDBACK_PATH = `${INSIGHTS_PATH}/${INSIGHTS_TAB_SLUGS.aiFeedbacks}`;
export const INSIGHTS_AI_FEEDBACK_DETAIL_PATH = `${INSIGHTS_AI_FEEDBACK_PATH}/:responseId`;

export type InsightsTabSlug = (typeof INSIGHTS_TAB_SLUGS)[keyof typeof INSIGHTS_TAB_SLUGS];
export const getInsightsTabPath = (tab: InsightsTabSlug) => `${INSIGHTS_PATH}/${tab}`;

export const getInsightsAiChatDetailPath = (chatId: string) =>
    `${getInsightsTabPath(INSIGHTS_TAB_SLUGS.aiChats)}/${chatId}`;

export const getInsightsAiFeedbackDetailPath = (responseId: string, chatId: string) => {
    const params = new URLSearchParams({ chatId });
    return `${getInsightsTabPath(INSIGHTS_TAB_SLUGS.aiFeedbacks)}/${responseId}?${params.toString()}`;
};

export const LINKS_PATH = '/links';
export const FILES_PATH = '/files';
export const CATEGORIES_PATH = '/categories';
export const STAFF_PATH = '/staff';
export const SETTINGS_PATH = '/settings';
export const SETTINGS_SMART_OPTIONS_PATH = `${SETTINGS_PATH}/smart-options`;

export const DATA_COLLECTIONS_PATH = '/data-collections';
export const DATA_COLLECTIONS_CREATE_PATH = `${DATA_COLLECTIONS_PATH}/create`;
export const DATA_COLLECTIONS_EDIT_PATH = `${DATA_COLLECTIONS_PATH}/:data_collection_id`;

export const CONTENT_MANAGEMENT_PATH = '/content-management';
export const CONTENT_MANAGEMENT_WELCOME_MESSAGE_PATH = `${CONTENT_MANAGEMENT_PATH}/welcome-message`;
export const CONTENT_MANAGEMENT_NEWS_ANNOUNCEMENTS_PATH = `${CONTENT_MANAGEMENT_PATH}/news-and-announcements`;
export const CONTENT_MANAGEMENT_SIDEBAR_LINKS_PATH = `${CONTENT_MANAGEMENT_PATH}/sidebar-links`;
export const CONTENT_MANAGEMENT_METHODOLOGY_PATH = `${CONTENT_MANAGEMENT_PATH}/methodology`;

export const SURVEYS_PATH = '/surveys';
export const SURVEY_CREATE_PATH = `${SURVEYS_PATH}/create`;
export const SURVEY_EDIT_PATH = `${SURVEYS_PATH}/:id`;

export const ORGANIZATIONS_PATH = '/organizations';
export const ORGANIZATION_PROFILE_PATH = `${ORGANIZATIONS_PATH}/:organization_id/profile`;
export const ORGANIZATION_MEMBERS_PATH = `${ORGANIZATIONS_PATH}/:organization_id/members`;
export const ORGANIZATION_LINKS_PATH = `${ORGANIZATIONS_PATH}/:organization_id/links`;
export const ORGANIZATION_FILES_PATH = `${ORGANIZATIONS_PATH}/:organization_id/files`;
export const ORGANIZATION_COLLECTIONS_PATH = `${ORGANIZATIONS_PATH}/:organization_id/collections`;
export const ORGANIZATION_PUBLIC_LISTS_PATH = `${ORGANIZATIONS_PATH}/:organization_id/public-lists`;
export const ORGANIZATION_WELCOME_MESSAGE_PATH = `${ORGANIZATIONS_PATH}/:organization_id/welcome-message`;
export const ORGANIZATION_WARNING_MESSAGE_PATH = `${ORGANIZATIONS_PATH}/:organization_id/warning-message`;
export const ORGANIZATION_SETTINGS_PATH = `${ORGANIZATIONS_PATH}/:organization_id/settings`;
